import _ from 'lodash';
import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as turf from '@turf/turf'

import createHistory from 'history/createHashHistory';

import Button from '../shared/components/Button';

import Map from '../shared/components/Map';

import { SAGA_GET_GEOFENCE } from './actions';

const history = createHistory();

const alertStyles = {
  width: '60%',
  position: 'fixed',
  top: 200,
  right: '20%',
  backgroundColor: '#FFFFFF',
  boxShadow: '0 0 9px 2px rgba(0,0,0,0.19)',
  zIndex: 100,
  padding: '2em',
  boxSizing: 'border-box',
};

const overlayStyles = {
  backgroundColor: 'rgba(10,10,10,0.4)',
  width: '100vw',
  height: '100vh',
  zIndex: 99,
  top: 0,
  position: 'fixed',
  left: 0,
};

const getRandomString = (len) => {
  let str = '';
  const space = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  for (let i = 0; i < len; i += 1) {
    let index = Math.floor(Math.random() * Math.floor(space.length));
    str += space[index];
  }
  return str;
}

class GeofenceCreate extends Component {
  constructor(props){
    super(props);

    this.state = {
      enableOnPremiseButton: true,
      enableInPremiseButton: false,
      enableInProximityButton: false,

      drawMode: false,
      drawInPremise: false,
      drawCustom: false,

      showRadiusDialog: false,

      showOnPremise: false,
      showInPremise: false,
      showInProximity: false,
      
      onPremiseFence: null,
      inPremiseFence: null,
      center: null,
      customFence: null,

      radius: 50,
    };

    this.createCustomGeofence = this.createCustomGeofence.bind(this);
    this.createAutomatedOnPremise = this.createAutomatedOnPremise.bind(this);
    this.drawInPremise = this.drawInPremise.bind(this);
    this.createInProximity = this.createInProximity.bind(this);
    this.removeAllFences = this.removeAllFences.bind(this);

    this.onUpdateRadius = this.onUpdateRadius.bind(this);
    this.onFenceDraw = this.onFenceDraw.bind(this);
    this.updateInProximity = this.updateInProximity.bind(this);
  }

  componentWillMount(){
    let geofenceId = this.props.match.params.geofence_id;
    this.props.getGeofence(geofenceId);
  }

  componentWillReceiveProps(nextProps) {
    const geofenceId = nextProps.match.params.geofence_id;

    if (nextProps.match.params.geofence_id !== this.props.match.params.geofence_id) {
        nextProps.getGeofence(geofenceId);
    }

    const geofence = nextProps.geofencesMap.get(geofenceId);

    this.setState({
      onPremiseFence: geofence.onPremise,
      inPremiseFence: null,
      center: geofence.geo,
    });
  }

  // Button Actions

  createCustomGeofence(){
    this.setState({
      drawCustom: true,
    });
  }
  
  createAutomatedOnPremise(){
    const geofenceId = this.props.match.params.geofence_id;
    const geofence = this.props.geofencesMap.get(geofenceId);

    this.setState({
      onPremiseFence: geofence.onPremise,
      showOnPremise: true,
      drawCustom: false,
      drawInPremise: false,
      enableInPremiseButton: true,
    }, () => {
      console.log(this.state);
    });
  }

  drawInPremise(){
    this.setState({
      drawInPremise: true,
    });
  }

  createInProximity(){
    this.setState({
      showRadiusDialog: true,
      drawCustom: false,
      drawInPremise: false,
    });
  }

  removeAllFences(){
    this.setState({
      drawCustom: false,
      drawInPremise: false,

      showInProximity: false,
      showOnPremise: false,

      inPremiseFence: null,
      customFence: null,
    });
  }

  onFenceDraw(newFence){
    const geofenceId = this.props.match.params.geofence_id;
    const geofence = this.props.geofencesMap.get(geofenceId);

    if (this.state.drawCustom) {
      this.setState({
        customFence: newFence.geometry,
        drawCustom: false,
        drawInPremise: false,
      });
    } 
    if (this.state.drawInPremise) {
      this.setState({
        inPremiseFence: newFence.geometry,
        drawCustom: false,
        drawInPremise: false,
      });
    }
  }

  onUpdateRadius(e) {
    let value = '';
    if (e.target.value !== '') {
      value = Number(e.target.value);
    }
    this.setState({
      radius: value,
    });
  }

  updateInProximity(){
    this.setState({
      showRadiusDialog: false,
      showInProximity: true,
    });
  }
  
  render() {
    const { props, state } = this;

    const geofenceId = props.match.params.geofence_id;
    const geofence = props.geofencesMap.get(geofenceId);

    if (_.isUndefined(geofence)) return null; 

    const polygons = [];

    let marker = {
      _id: `${getRandomString(4)}`,
      geo: geofence.geo,
    };

    if (!_.isNull(state.customFence) && state.customFence) {
      const fenceId = `${geofence._id}-custom-${getRandomString(4)}`;
      
      const tmpPolygon = {
        _id: fenceId,
        geo: state.customFence,
        color: '#96C944',
      };

      polygons.push(tmpPolygon);

      const turfPolygon = turf.polygon(tmpPolygon.geo.coordinates);
      const center = turf.centerOfMass(turfPolygon);

      marker = {
        _id: `${geofence._id}-marker-${getRandomString(4)}`,
        geo: center.geometry,
      };
    }

    if (!_.isNull(state.onPremiseFence) && state.showOnPremise) {
      const fenceId = `${geofence._id}-on-premise-${getRandomString(4)}`;
      
      const tmpPolygon = {
        _id: fenceId,
        geo: state.onPremiseFence,
        color: '#9013FE',
      };
      polygons.push(tmpPolygon);

      const turfPolygon = turf.polygon(tmpPolygon.geo.coordinates);
      const center = turf.centerOfMass(turfPolygon);

      marker = {
        _id: `${geofence._id}-marker-${getRandomString(4)}`,
        geo: center.geometry,
      };
    }

    if (!_.isNull(state.inPremiseFence) && state.inPremiseFence) {
      const fenceId = `${geofence._id}-custom-in-premise-${getRandomString(4)}`;
      
      const tmpPolygon = {
        _id: fenceId,
        geo: state.inPremiseFence,
        color: '#2DE6D5',
      };

      polygons.push(tmpPolygon);

      const turfPolygon = turf.polygon(tmpPolygon.geo.coordinates);
      const center = turf.centerOfMass(turfPolygon);

      marker = {
        _id: `${geofence._id}-marker-${getRandomString(4)}`,
        geo: center.geometry,
      };
    }

    if (!_.isNull(state.center) && state.showInProximity) {
      polygons.push({
        _id: `${geofence._id}-${state.radius}`,
        geo: marker.geo,
        color: '#FCC974',
        radius: state.radius,
      });
    }

    const center = {
      lng: marker.geo.coordinates[0],
      lat: marker.geo.coordinates[1],
    };

    return (
      <div>
        <div className="content-area">
          <div className="container">
            <div style={{ display: 'flex' }}>
              <div style={{ width: 400 }}>
                <h3 className="heading">Geofence Creation</h3>
                <h4 className="sub-heading" style={{ marginBottom: 26 }}>
                  Geofence the Point of Interest
                </h4>
              </div>
              <div style={{flexGrow: 1, textAlign: 'right'}}>
                <button
                  className="btn btn-blue" 
                  onClick={() => {
                      history.push(`/confirmGeofence`);
                  }}
                >
                  New POI
                </button>
              </div>
            </div>
            <div style={{ width: '100%', height: 400, paddingBottom: 42 }}>
              <Map 
                  drawMode={state.drawInPremise || state.drawCustom} 
                  editMode={false} 
                  mapCenter={center}
                  polygons={polygons} 
                  markers={[marker]}
                  circles={[geofence.geo]} 
                  key="create-geofence"
                  newFenceDrawn={this.onFenceDraw} />
            </div>
          </div>
        </div>

        {state.showRadiusDialog ? (
          <div>
            <div className="alert" style={alertStyles}>
              <h3>Choose In-Proximity radius</h3>
              <input 
                  placeholder="" 
                  style={{ width: '100%' }}
                  type="number" 
                  value={state.radius}
                  onChange={this.onUpdateRadius}
              />
              <button
                className="btn btn-blue" 
                style={{ flexGrow: 1, margin: '1em 0em' }}
                disabled={state.radius === ''}
                onClick={this.updateInProximity}
              >
                Confirm
              </button>
            </div>
            <div style={overlayStyles} />
          </div>
        ) : null}
        
        
        <div className="content-area" style={{ marginTop: 16 }}>
          <div className="container" style={{ paddingBottom: 40 }}>
            <div style={{ width: '70%', float: 'left' }}>
              <div className="form-field" style={{ width: '100%' }}>
                <label>Street address</label>
                <span className="dummy-input">{geofence.formattedAddress}</span>
              </div>
              <div className="data-area">
                {geofence.boundaryData.map((region,i) => (
                  <div className="column" key={i}>
                    <p><b>{region.key}: </b>
                        <span style={{ textTransform: 'capitalize' }}>
                          {region.value === null ? 'N/A' : region.value.toLowerCase()}
                        </span>
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, float: 'right', paddingTop: '2em' }}>
              {/* On Premise*/}
              <Button
                style={{ flexGrow: 1 }} 
                disabled={geofence.onPremise === null || geofence.onPremise.coordinates.length === 0}
                onClick={this.createAutomatedOnPremise}
                outlined={true}
                color="purple"
              >
                Automated On-Premise
              </Button>

              {/* Draw In-Premise button */}
              <Button
                style={{ flexGrow: 1 }}
                disabled={false}
                onClick={this.drawInPremise}
                outlined={true}
                color="teal"
              >
                Draw In-Premise
              </Button>


              {/* In-Proximity button */}
              <Button
                style={{ flexGrow: 1 }}
                disabled={false} 
                outlined={true}
                onClick={this.createInProximity}
                color="yellow"
              >
                Create In-Proximity
              </Button>

              {/* Create Custom Geofence button */}
              <Button
                style={{ flexGrow: 1 }}
                disabled={false}
                onClick={this.createCustomGeofence}
                outlined={true}
                color="green"
              >
                Draw Custom Geofence
              </Button>

              {/* Draw In-Premise button */}
              <Button className="btn btn-green" 
                style={{ flexGrow: 1 }}
                disabled={false}
                outlined={true}
                color="black"
                onClick={this.removeAllFences}
              >
                Remove All Geofence
              </Button>
            </div>
            <div style={{ clear: 'both' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

GeofenceCreate.propTypes = {
  getGeofence: PropTypes.func,
  geofencesMap: PropTypes.instanceOf(Immutable.Map),
};

// Map props to the store

const mapStateToProps = (state) => ({
  geofencesMap: state.geofence.get('geofencesMap'),
});

const mapDispatchToProps = (dispatch) => ({
  getGeofence: (geofenceId) => {
    dispatch({
      type: SAGA_GET_GEOFENCE,
      payload: {
        geofenceId,
      },
    });
  },
})

const GeofenceCreateContainer = connect(mapStateToProps,mapDispatchToProps)(GeofenceCreate);

export default GeofenceCreateContainer;


// WEBPACK FOOTER //
// ./src/Geofence/GeofenceCreate.js